import { Flex, Typography } from '@aloft/toolkit-sui';

type DetailLineProps = {
  text?: string;
  noPadding?: boolean;
};

export const DetailLine = ({ text = '', noPadding = false }: DetailLineProps) => {
  const textWrapSx = { textOverflow: 'ellipsis', textWrap: 'nowrap', overflow: 'hidden' };

  return (
    <Flex paddingRight={noPadding ? '0' : '5rem'}>
      <Typography __dangerDoNotUseSx={textWrapSx}>{text}</Typography>
    </Flex>
  );
};
